import { genericError, silentError } from './action-utils'
import BasisConfirmationServiceApi from '../../api/basis-confirmation-service-api'
import { request } from './auth-actions'
import { notify } from './notification-actions'
import { getText } from '../../internal/TextLabels'
import { NOTIFY_SUCCESS, NOTIFY_DANGER } from './action-types'
import isInternetExplorer from '../../util/internetExplorerHelper'

export const sendBasisConfirmation = body => dispatch => {
  return dispatch(
    request(BasisConfirmationServiceApi.sendBasisConfirmation(body)),
  )
    .then(response => {
      if (!response.cellphone) {
        notify(NOTIFY_DANGER, getText('payApply.basisConfirmation.error'))
      } else {
        notify(NOTIFY_SUCCESS, getText('payApply.basisConfirmation.smsSent'))
      }
    })
    .catch(error => {
      genericError(error)
      throw error
    })
}

export const getBasisConfirmationPdf = (body, documentName) => dispatch => {
  return dispatch(
    request(BasisConfirmationServiceApi.fetchConfirmationPdf(body)),
  )
    .then(b => {
      const blob = new Blob([b], { type: 'application/pdf' })
      if (isInternetExplorer()) {
        window.navigator.msSaveOrOpenBlob(blob, `${documentName}.pdf`)
        return null
      }
      return URL.createObjectURL(blob)
    })
    .catch(error => {
      if (error.status === 422 || error.status === 400) {
        silentError(error)
        notify(NOTIFY_DANGER, getText('payApply.basisConfirmation.pdfError'))
      } else {
        genericError(error)
        throw error
      }
    })
}
